module.exports = __webpack_public_path__ + "static/img/4.a2849ee.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/4/zh/4.png
// module id = r0JZ
// module chunks = 0